import { SortingState } from '@tanstack/react-table';
import { SortConfig } from '@/types';

export function sortingStateToSortConfig(sorting: SortingState): SortConfig {
  if (!sorting.length) return {};
  const [{ id, desc }] = sorting;
  return { sort_by: id, sort_type: desc ? 'desc' : 'asc' };
}
